import axios from "axios";

axios.defaults.timeout = 10000;
axios.defaults.baseURL = "";

//http request 拦截器
axios.interceptors.request.use(
  config => {
    let url=config.url
    if(url.indexOf('d0c9677e482a4a16829b30aa70eecaa2')!==-1){
      config.headers={
        "Content-Type": "application/x-www-form-urlencoded",
      }
    }else if(url.indexOf('c86897790c9740929cb73ceee0ca8588')!==-1){
      config.headers={
        "Content-Type": "multipart/form-data",
        "encodedTenantId":"FF15721EF3DCC3E8570950805D851D5265F8D2A2144419"
      }
    }else{
      config.headers = {
        "Content-Type": "application/json;charset=UTF-8",
        "encodedTenantId":"FF15721EF3DCC3E8570950805D851D5265F8D2A2144419"
      }
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.errCode == 2) {
      router.push({
        path: "/",
        query: { redirect: router.currentRoute.fullPath } //从哪个页面跳转
      });
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
